'use strict'

import format from 'string-format'
import session from './session'
import {obj_to_FormData} from "./utils"

export default {

	plate_list(project_id) {

		const params = {}
		if (project_id) {
			// фильтр Django
			params['projects_id'] = project_id
		}

		return session.get('plate/', {params: params})
			.catch(function (error) {
				console.error(format(
					"method: '{method}' url: '{url}'" + "\n" +
					"error: '{error}'.",
					{
						method: error.config.method,
						url: error.config.url,
						error: error.toString()
					}))
				throw error
			})
	},

	plate_get(plate_id) {
		return session.get(format('plate/{id}/', {id: plate_id}))
	},

	plate_create(plate) {
		return session.request({
			method: 'POST',
			url: format('plate/'),
			data: plate,
		})
	},

	plate_update(plate, details = true) {
		const data = obj_to_FormData(plate)

		return session.request({
			method: 'PATCH',
			url: format('plate/{id}/', {id: plate.id}),
			headers: {'Content-Type': 'multipart/form-data',},
			data
		})
	},

	plates_delete(plate_id_list) {
		return session.request({
			method: 'POST',
			url: format('plate/delete_list/'),
			data: plate_id_list
		})
	},

	update_wells(plate_id, well_nums, props) {
		console.info("api/plate/update_wells()")

		return session.request({
			method: 'POST',
			url: format(
				'plate/{plate_id}/update_wells/',
				{plate_id: plate_id}),
			data: {well_nums: well_nums, props: props}
		})
	},

	load_well_spectra(plate_id, well_num) {
		return session.get(format(
			'plate/{plate_id}/well_num/{well_num}/spectra/',
			{plate_id: plate_id, well_num: well_num}))
	},

	/**
	 * Get probes' data of well (with background).
	 * @param plate_id
	 * @param well_num
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	load_well_probe_data(plate_id, well_num) {
		return session.get(format(
			'plate/{plate_id}/well_num/{well_num}/probe_data/',
			{plate_id: plate_id, well_num: well_num}))
	},

	plate_process_file(plate_id) {
		if (!plate_id) {
			throw Error("Argument 'plate_id' error")
		}

		return session.post(
			format('plate/{id}/process_file/', {id: plate_id}),
			{})
	},

	plate_process_spectra(plate_id) {
		if (!plate_id) {
			throw Error("Argument 'plate_id' error")
		}

		return session.post(
			format('plate/{id}/process_spectra/', {id: plate_id}),
			{})
	},

	plate_calc_background(plate_id) {
		if (!plate_id) {
			throw Error("Argument 'plate_id' error")
		}

		return session.post(
			format('plate/{id}/calc_background/', {id: plate_id}),
			{})
	},

}